import type { FC, ReactNode } from 'react'

import RichText from '@/components/cms/rich-text'
import { cn } from '@/lib/utils'

interface ArticleBodyProps {
    html: string | null
    className?: string
}

/**
 * Article typography applied from the outside of the shared rich text styles.
 * rich-text.css is unlayered, so the overrides of properties it sets carry `!`.
 */
const bodyClasses = [
    'max-w-[68ch] text-[1.06rem] leading-[1.8] text-foreground/90',
    '[&_h2]:mt-14! [&_h2]:font-display! [&_h2]:text-[2rem]! [&_h2]:font-normal! [&_h2]:leading-[1.12]! [&_h2]:tracking-[-0.01em] [&_h2]:text-foreground',
    '[&_h3]:mt-10! [&_h3]:text-[1.2rem]! [&_h3]:text-foreground',
    '[&_strong]:font-semibold [&_strong]:text-foreground',
    '[&_li]:pl-1 [&_li::marker]:text-primary',
    '[&_blockquote]:my-10 [&_blockquote]:border-l-2! [&_blockquote]:border-primary! [&_blockquote]:pl-6! [&_blockquote]:font-display [&_blockquote]:text-[1.55rem] [&_blockquote]:leading-snug [&_blockquote]:text-foreground',
    '[&_table]:mt-8! [&_table]:w-full [&_table]:text-[0.95rem] [&_table]:leading-normal',
    '[&_th]:border-b [&_th]:border-foreground/20 [&_th]:py-3! [&_th]:pr-6! [&_th]:text-xs [&_th]:font-semibold [&_th]:uppercase [&_th]:tracking-[0.12em] [&_th]:text-muted-foreground',
    '[&_td]:border-b [&_td]:border-border [&_td]:py-3! [&_td]:pr-6! [&_td]:text-foreground/85'
].join(' ')

export const ArticleBody: FC<ArticleBodyProps> = ({ html, className }): ReactNode => {
    if (!html || html.trim() === '') return null

    return <RichText html={html} className={cn(bodyClasses, className)} />
}
